import { BaseMaskAdapter } from "./base-adapter";

export class QuantityPresetAdapter extends BaseMaskAdapter {
  constructor() {
    super("");
  }
  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyQuantityMask(String(value));
  }

  parseFromInput(inputValue: string): { value: string; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: "", formatted: "" };
    }

    const formatted = this.applyQuantityMask(inputValue);
    // For quantity preset, return the numeric value in US format (periods for thousands removed, comma replaced with period)
    const cleanValue = formatted.replace(/\./g, "").replace(/,/g, ".");

    return {
      value: cleanValue,
      formatted,
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyQuantityMask(String(value));
  }

  private applyQuantityMask(value: string): string {
    // Remove everything except digits and comma (Brazilian decimal separator)
    const cleaned = value.replace(/[^\d,]/g, "");

    // Handle multiple commas - keep only the first one
    const parts = cleaned.split(",");
    if (parts.length > 2) {
      const formatted = `${parts[0]},${parts.slice(1).join("")}`;
      return formatted;
    }

    // Split into integer and decimal parts
    const [integerPart, decimalPart] = parts;

    // Format integer part with periods (Brazilian thousands separator)
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Return formatted number
    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : formattedInteger;
  }

  isKeyAllowed(key: string, currentValue: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    // Allow digits
    if (/^\d$/.test(key)) {
      return true;
    }
    // Allow comma only if there's no comma yet
    if (key === ",") {
      return !currentValue.includes(",");
    }
    return false;
  }
}
